import { Controller } from "@hotwired/stimulus"

function scrollToAnchorWithOffset(anchorId, offset = 120) {
  const element = document.getElementById(anchorId);
  if (!element) return;

  // 找到可滚动的容器（带有 overflow-scroll 的 div）
  const scrollContainer = document.querySelector('.overflow-scroll') || document.querySelector('.overflow-y-scroll') || window;

  if (scrollContainer === window) {
    // 使用 window 滚动
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  } else {
    console.log("rongqimw")
    // 在容器内滚动
    const containerRect = scrollContainer.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const scrollPosition = elementRect.top - containerRect.top + scrollContainer.scrollTop - offset;

    scrollContainer.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }
}


export default class extends Controller {
  // 用事件委托绑定在容器上：导航列表被 turbo_stream 重渲染后新元素依然生效
  scrollToQuestion(event) {
    const link = event.target.closest('a[data-scroll-question]')
    if (!link) return
    event.preventDefault()
    event.stopPropagation()

    const targetId = link.getAttribute('href')
    if (!targetId) return

    // 提取 anchor ID（去掉 # 符号）
    const anchorId = targetId.replace('#', '')

    // 使用带偏移量的滚动函数
    scrollToAnchorWithOffset(anchorId, 120)

    // 更新 URL hash
    history.pushState(null, null, targetId)
  }
}
